import React from "react";
import { Link } from "react-router-dom";
import { Offer } from "../utils/API";

const CouponRecommendations: React.FC<{
  brandListData: Offer[];
  detailLinkParams?: {
    source: string;
    brandType?: string;
  };
}> = ({ brandListData, detailLinkParams }) => {
  const buildDetailLink = (item: Offer) => {
    const params = new URLSearchParams({
      offer_id: item.offer_id,
      store: item.store,
    });
    if (detailLinkParams?.source) {
      params.set("source", detailLinkParams.source);
    }
    if (detailLinkParams?.brandType) {
      params.set("brand_type", detailLinkParams.brandType);
    }
    return `/branddiscountcode?${params.toString()}`;
  };

  return (
    <>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 gap-5 gap-x-[23px] md:gap-[30px] mx-auto px-[26px] md:px-[76px]">
        {brandListData?.map((item) => {
          const logoUrl = (item.brand_logo || "")
            .replace("[size]", "200")
            .replace("[format]", "png");
          const brandName = item.merchant_name || item.title;
          return (
            <Link
              to={buildDetailLink(item)}
              key={item.offer_id}
              target="_top"
              rel="noopener noreferrer"
            >
              <div
                className="coupon-item flex-col shadow-coupon py-2.5 px-3.5 md:py-4 md:px-6 max-w-[280px] h-[183px] md:h-[220px] lg:h-[250px] xl:h-[300px] cursor-pointer transition-all duration-300 hover:scale-105 hover:shadow-xl hover:shadow-[#ef312b33] relative overflow-hidden group"
                style={{
                  background:
                    "url(/images/discount-bg-m.png) no-repeat center center / 100% 100% ",
                }}
              >
                <div className="absolute inset-0 bg-gradient-to-br from-primary-500/0 via-primary-500/0 to-primary-500/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <div className="flex flex-col justify-center items-center gap-5 md:gap-7 lg:gap-10 xl:gap-12">
                  <div className="flex justify-center items-center rounded-[10px] transition-transform duration-300 group-hover:scale-110 group-hover:rotate-3 pt-4">
                    <img
                      src={logoUrl}
                      alt={brandName || "brand logo"}
                      referrerPolicy="no-referrer"
                      crossOrigin="anonymous"
                      loading="lazy"
                      decoding="async"
                      // fetch-priority="auto"
                      width="100"
                      height="100"
                      className="w-[80px] h-[80px] md:w-[90px] md:h-[90px] lg:w-[100px] lg:h-[100px] xl:w-[118px] xl:h-[118px] rounded-[10px] object-contain"
                    />
                  </div>

                  <div className="flex flex-col justify-center items-center gap-1 mt-4">
                    <div className="text-[10px] md:text-[13px] md:leading-4 lg:text-sm lg:leading-4 xl:text-base xl:leading-5 font-semibold leading-3 text-center line-clamp-1 text-white">
                      {brandName}
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          );
        })}
      </div>
      {/* <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 gap-5 gap-x-[23px] md:gap-[30px] mx-auto px-[26px] md:px-[100px]">
      <div>
        <div
          className="coupon-item flex-col shadow-coupon py-2.5 px-3.5 md:py-4 md:px-6 h-[183px] md:h-[220px] lg:h-[250px] xl:h-[300px] cursor-pointer transition-all duration-300 hover:scale-105 hover:shadow-xl hover:shadow-[#ef312b33] relative overflow-hidden group"
          style={{
            background:
              "url(/images/discount-bg-m.png) no-repeat center center / 100% 100%",
          }}
          onClick={handleJumpToBranddiscountcode}
        >
          <div className="absolute inset-0 bg-gradient-to-br from-primary-500/0 via-primary-500/0 to-primary-500/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
          <div className="flex flex-col justify-center items-center gap-1 md:gap-1.5 lg:gap-2 xl:gap-2">
            <div className="flex justify-center items-center rounded-[10px] transition-transform duration-300 group-hover:scale-110 group-hover:rotate-3">
              <img
                src="https://static.gofreedeal.com/content/coupon/1754364820331_b0438549891ee470.webp"
                alt="セフォラ割引コード - 50%オフ"
                loading="lazy"
                decoding="async"
                fetch-priority="auto"
                width="100"
                height="100"
                className="w-[60px] h-[60px] md:w-[70px] md:h-[70px] lg:w-[80px] lg:h-[80px] xl:w-[98px] xl:h-[98px] rounded-[10px] object-contain"
              />
            </div>
            <div className="text-xs leading-4 min-h-[32px] md:text-sm md:min-h-[32px] md:leading-4 lg:text-base lg:leading-5 lg:min-h-[40px] xl:text-xl xl:min-h-[56px] font-bold text-center line-clamp-2 text-[#130300] opacity-80">
              セフォラ割引コード - 50%オフ
            </div>
          </div>
          <div className="flex flex-col justify-center items-center gap-1 mt-4">
            <div className="text-[26px] leading-8 md:text-[32px] md:leading-9 lg:text-[36px] lg:leading-10 xl:text-[38px] xl:leading-[52px] font-black text-center line-clamp-1 text-white">
              SAVE WITH CODE
            </div>
            <div className="text-[10px] md:text-[13px] md:leading-4 lg:text-sm lg:leading-4 xl:text-base xl:leading-5 font-semibold leading-3 text-center line-clamp-1 text-white">
              6,064 人が利用しました
            </div>
          </div>
        </div>
      </div>
    </div> */}
    </>
  );
};

export default CouponRecommendations;
